<template>
  <div class="direct-document">
    <h1>
      <span>{{ $t('interface.registerCard') }}</span>
      <div class="sub">{{direct.organization__name}} №{{direct.registration_number}} {{direct.registered_date | date}}</div>
    </h1>
    <table>
      <tr>
        <td width="55%">{{ $t('docflow.organization') }}: <span class="bold">{{direct.sender__name}}</span></td>
        <td>
          <p>{{ $t('docflow.fields.original_document_number') }}:
            <span class="bold">{{direct.original_document_number}}</span></p>
          <p>{{ $t('docflow.fields.original_document_date') }}:
            <span class="bold">{{direct.original_document_date | date}}</span></p>
        </td>
      </tr>
      <tr>
        <td>
          <p>{{ $t('docflow.fields.delivery_type') }}: <span class="bold">{{direct.delivery_type__name}}</span></p>
          <p>
            <span v-if="direct.is_informational">{{$t('docflow.is_informational')}}</span>
            <template v-if="direct.is_informational && direct.is_classified">/</template>
            <span v-if="direct.is_classified">{{$t('docflow.is_classified')}}</span>
          </p>
        </td>
        <td>{{ $t('docflow.fields.term_date') }}: <span class="bold">{{direct.term_date | date}}</span></td>
      </tr>
    </table>
    <div class="block">
      <span class="underline">{{ $t('interface.description') }}:</span> {{direct.description}}
    </div>
    <div class="block">
      <span class="underline">{{ $t('docflow.resolution') }}:</span>
      <ul>
        <li v-for="task in direct.resolution_tasks">
          {{ task.employee.fullname }}: {{ task.description }},
          {{ $t('direct.term') }} {{task.term_date | date}}
        </li>
      </ul>
    </div>
    <table>
      <tr>
        <td width="55%">
          <p>{{ $t('docflow.maintainer') }}:
            <span class="bold">{{direct.resolution_maintainer__initials}}</span></p>
          <p>{{ $t('admin.post_name') }}:
            <span class="bold">{{direct.resolution_maintainer__post_name}}</span></p>
        </td>
        <td>
          <p>{{ $t('docflow.approver') }}:
            <span class="bold">{{direct.resolution_approver__initials}}</span></p>
          <p>{{ $t('admin.post_name') }}:
            <span class="bold">{{direct.resolution_approver__post_name}}</span></p>
        </td>
      </tr>
      <tr>
        <td>
          <p class="mt-15">{{ $t('docflow.fields.supervisor') }}:
            <span class="bold">{{direct.supervisor__initials}}</span></p>
          <p>{{ $t('admin.post_name') }}:
            <span class="bold">{{direct.supervisor__post_name}}</span></p>
          <p>{{ $t('documents.fields.term') }}:
            <span class="bold">{{direct.resolution_term_date | date}}</span></p>
        </td>
      </tr>
      <tr>
        <td>
        </td>
        <td>
          <p class="mt-30">{{ $t('direct.doneDay') }}:
            <span class="bold">_______________</span></p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState('Docflow', ['direct'])
    }
  }
</script>

<style lang="scss" scoped>
  .direct-document {
    font-size: 16px;
    line-height: 28px;

    h1 {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;

      .sub {
        font-size: 16px;
      }
    }
    table {
      width: 100%;
      margin-bottom: 20px;
      tr {
        td:first-child {
          padding-right: 20px;
        }
      }
    }
    .bold {
      font-weight: bold;
    }
    .underline {
      text-decoration: underline;
    }
    ul {
      list-style: disc;
      li {
        margin-left: 18px;
      }
    }
  }
</style>
